import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Button } from "../Button/Button.js";
import { Icon } from "../../Icon/Icon.js";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
const SelectCreateNewWrapper = ({ onClick, children }) => {
  const prefix = useClassNamePrefix();
  if (!onClick) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsxs("div", { className: `${prefix}selectCreateNewWrapper`, children: [
    /* @__PURE__ */ jsx("div", { className: `${prefix}selectCreateNewWrapper-control`, children }),
    /* @__PURE__ */ jsx("div", { className: `${prefix}selectCreateNewWrapper-button`, children: /* @__PURE__ */ jsx(Button, { onClick, elevation: "none", intent: "default", children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "plus" }) }) })
  ] });
};
export {
  SelectCreateNewWrapper
};
//# sourceMappingURL=SelectCreateNewWrapper.js.map
